import Button from "../Button";
import { RulesAndDataDiagram } from "./subcomponents/Diagrams";

import usePersistedEnvironmentState from "../../src/usePersistedEnvironmentState";
import { useRouter } from "next/router";
import { useEffect } from "react";
import FadeIn from "react-fade-in";
import { AiOutlineArrowLeft } from "react-icons/ai";
import {
  HiArrowRight,
  HiDatabase,
  HiLightningBolt,
  HiPencil,
} from "react-icons/hi";

export const SummaryPage: React.FC<{
  onBack: () => void;
  logAnalytics?: (message: string) => void;
}> = ({ onBack, logAnalytics }) => {
  const router = useRouter();
  const [hasCompletedGetStartedFlow, setHasCompletedGetStartedFlow] =
    usePersistedEnvironmentState("has_completed_get_started_flow");
  useEffect(() => {
    setHasCompletedGetStartedFlow(true);
  }, [hasCompletedGetStartedFlow]);

  return (
    <FadeIn>
      <div className="mx-auto max-w-[800px]">
        {/* TODO confetti?! */}
        <FadeIn>
          <h2 className="text-2xl">{"You're"} ready to go!</h2>
          <div className="mt-3" />
          <div className="flex flex-col space-y-3">
            <p>
              You modeled some rules, added a few pieces of authorization data,
              and ran some authorization enforcement requests.
            </p>
            <div className="w-1/2 mx-auto">
              <RulesAndDataDiagram />
            </div>
            <p>{"You've"} got down the basics of Oso Cloud!</p>
          </div>
        </FadeIn>
        <FadeIn delay={750}>
          <div className="mt-3 flex flex-col space-y-3">
            <p>Now {"you're"} ready to:</p>

            <div className="flex flex-row justify-between items-stretch space-x-8 text-lg">
              <div className="flex flex-col items-stretch space-y-2 basis-1/3">
                <div className="p-6 bg-oso-light-blue rounded h-full w-full">
                  <HiPencil className="text-2xl mx-auto" />
                  <div>Tweak your rules to fit your domain</div>
                </div>
                <Button
                  medium
                  icon={<HiArrowRight />}
                  className="w-full"
                  onClick={(e) => {
                    e.preventDefault();
                    if (logAnalytics) logAnalytics("Use Rules Editor");
                    router.push("/rules-editor");
                  }}
                >
                  Use the Rules Editor
                </Button>
              </div>

              <div className="flex flex-col items-stretch space-y-2 basis-1/3">
                <div className="p-6 bg-oso-light-blue rounded h-full w-full">
                  <HiDatabase className="text-2xl mx-auto" />{" "}
                  <div>Grant users more permissions</div>
                </div>
                <Button
                  medium
                  icon={<HiArrowRight />}
                  className="w-full"
                  onClick={(e) => {
                    e.preventDefault();
                    if (logAnalytics) logAnalytics("Add More Data");
                    router.push("/facts");
                  }}
                >
                  Add more data
                </Button>
              </div>

              <div className="flex flex-col items-stretch space-y-2 basis-1/3">
                <div className="p-6 bg-oso-light-blue rounded h-full w-full">
                  <HiLightningBolt className="text-2xl mx-auto" />{" "}
                  <div>Review what you&apos;ve learned</div>
                </div>
                <Button
                  medium
                  theme="primary"
                  icon={<HiArrowRight />}
                  className="w-full"
                  onClick={(e) => {
                    e.preventDefault();
                    if (logAnalytics) logAnalytics("Visit Quickstart");
                    window.open(
                      "https://www.osohq.com/docs/quickstart",
                      "_blank"
                    );
                  }}
                >
                  Visit the Quickstart
                </Button>
              </div>
            </div>
          </div>
        </FadeIn>
        <div className="mt-8" />
        <Button icon={<AiOutlineArrowLeft />} small onClick={onBack}>
          Back
        </Button>
      </div>
    </FadeIn>
  );
};
